const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "10px",
    },
    main: {
        // marginTop: "20px",
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
        border: `1px solid ${theme.palette.divider}`
    },
    toolBar: {
        paddingLeft: "0px",
        paddingRight: "0px",
        minHeight: "30px",
    },
    labelIcon: {
        color: theme.palette.primary.main,
    },
    inputContainer: {
        marginTop: "20px",
    },
    buttonContainer: {
        marginTop: "20px",
        marginBottom: "20px",
    },
    codeBlock: {
        backgroundColor: theme.palette.background.elevated,
        color: theme.palette.text.primary,
        padding: 15,
    },
    code: {
        fontFamily: "monospace",
    },
    tabSwitchIcon: {
        marginLeft: theme.spacing(0.5),
        fontSize: "1.2rem",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.short
        })
    },
    tabSwitchIconActive: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected
    },
    tabSwitchText: {
        fontSize: "0.8rem",
        fontWeight: 600,
        paddingRight: theme.spacing(3),
        cursor: "pointer",
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['color'], {
            duration: theme.transitions.duration.short
        })
    },
    tabSwitchActive: {
        color: theme.palette.text.primary
    },
    lossText: {
        fontSize: "0.9rem",
        fontWeight: 500,
    },
    statusIcon: {
        fontSize: "1.1rem",
        marginLeft: theme.spacing(0.6),
        marginRight: theme.spacing(0.5)
    },
    statusPublished: {
        color: theme.palette.success.main
    },
    statusSubmitted: {
        color: theme.palette.warning.main
    },
    statusRejected: {
        color: theme.palette.error.main
    },
    statusDraft: {
        color: theme.palette.info.main
    }

});

export default styles;
